import React from "react";

const LoadingSpinner = () => {
  const isMobile = window.innerWidth <= 768;
  const size = isMobile ? 80 : 100; 

  return (
    <div
      style={{
        position: "fixed",
        top: 0,
        left: 0,
        width: "100vw",
        height: "100vh",
        backgroundColor: "#ffffff",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        zIndex: 9999,
      }}
    >
      <img
        src="/images/loader-symbol.gif" 
        alt="Loading"
        style={{
          width: `${size}px`,
          height: `${size}px`,
          objectFit: "cover",
        }}
      />
    </div>
  );
};

export default LoadingSpinner;
